<template>
<div>
  <el-button  style="width:100%" type="secondary" size="small" @click="open">인터페이스 제어</el-button>
  <w-sliding-popup ref="slidingPopup" title="인터페이스 제어" top="50px" width="700px" @close="close">
    <div slot="content" v-loading="loading">
      <div class="title-h4 title-bar">인터페이스 <em class="mr-l4 mr-r4">{{ `${formData.netinterfaceName} (${formData.netinterfaceDevicename})` }}</em>제어</div>
      <el-row class="gray-box vertical-center-box mr-b25" type="flex">
        <span>Admin 상태</span>
        <el-switch v-model="netinterfaceAdminStatusValue" :active-value="1" :inactive-value="0" @change="onSwitchChange"></el-switch>
      </el-row>
      <el-row type="flex" justify="space-between" :gutter="10">
        <el-col :span="12" class="list form-list">
          <div class="title-h4 title-bar">기본 정보</div>
          <el-form ref="configForm" :model="formData" label-width="120px" label-position="left" class="mr-b20">
            <el-form-item label="그룹명"><span>{{ getInterfaceLabel(formData.managegroupName) }}</span></el-form-item>
            <el-form-item label="인터페이스명"><span>{{ formData.netinterfaceName }}</span></el-form-item>
            <el-form-item label="인터페이스 IP"><span>{{ getValueAfterCheckEmpty(formData.ipaddress) }}</span></el-form-item>
            <el-form-item label="MAC 주소"><span>{{ getValueAfterCheckEmpty(formData.netinterfaceMacaddress) }}</span></el-form-item>
            <el-form-item label="인터페이스 종류"><span>{{ formData.interfaceType }}</span></el-form-item>
            <el-form-item label="대역폭"><span>{{ thousandSep(formData.netinterfaceSpeed) }}</span></el-form-item>
            <el-form-item label="대역폭 갱신"><span>{{ formData.updateFlag }}</span></el-form-item>
            <el-form-item label="인덱스"><span>{{ getValueAfterCheckEmpty(formData.netinterfaceIfindex) }}</span></el-form-item>
            <el-form-item label="별칭"><span>{{ getValueAfterCheckEmpty(formData.netinterfaceAlias) }}</span></el-form-item>
            <el-form-item label="Duplex"><span>{{ getValueAfterCheckEmpty(formData.netinterfaceDuplex) }}</span></el-form-item>
            <el-form-item label="Oper 상태"><span>{{ convertStatus(formData.netinterfaceStatusOper) }}</span></el-form-item>
            <el-form-item label="Admin 상태"><span>{{ convertStatus(formData.netinterfaceStatusAdmin) }}</span></el-form-item>
            <el-form-item label="설명"><span>{{ getValueAfterCheckEmpty(formData.netinterfaceDevicename) }}</span></el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12" class="list form-list">
          <div class="title-h4 title-bar">네트워크 장비 정보</div>
          <el-form :model="formData" label-width="120px" label-position="left">
            <el-form-item label="장비명"><span>{{ formData.deviceObjName }}</span></el-form-item>
            <el-form-item label="ipaddress"><span>{{ getValueAfterCheckEmpty(formData.deviceIpaddress) }}</span></el-form-item>
            <el-form-item label="장비 종류"><span>{{ getValueAfterCheckEmpty(formData.deviceObjtypeName) }}</span></el-form-item>
            <el-form-item label="제조사"><span>{{ getValueAfterCheckEmpty(formData.deviceObjCompanyName) }}</span></el-form-item>
            <el-form-item label="모델"><span>{{ getValueAfterCheckEmpty(formData.deviceObjProductId) }}</span></el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </div>
    <div slot="footer">
      <el-button type="solid" size="large" :disabled="!changedFlag" @click="onSaveButtonClick">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </div>
  </w-sliding-popup>
</div>
</template>

<script>
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import configNDAPI from '@/api/config/netdevice/netdevice-info';
import configNIAPI from '@/api/config/netinterface/netinterface-info';
import netinterfaceAPI from '@/api/performance/netinterface/netinterface-info';
import isEmpty from 'lodash/isEmpty';

export default {
  name: 'WNetinterfaceControlPopupButton',
  props: {
    objInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
      changedFlag: false,
      parentObjId: null,
      netinterfaceAdminStatusValue: null,
      formData: {}, // Form 바인딩 데이터
    };
  },
  computed: {
    parentLabel() {
      return !isEmpty(this.objInfo.parent) ? this.objInfo.parent.label : '';
    },
  },
  created() {
    configNDAPI.getNetinterfaceObjInfo({
      objId: this.objInfo.obj.objId,
    }).then((response) => {
      this.parentObjId = response.data.data.parentObjId;
    });
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.loadData();
    },
    loadData() {
      configNIAPI.getNiConfigInfoBasic({
        objId: this.objInfo.obj.objId,
        managegroupId: this.parentObjId,
      }).then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          if (data.netinterfaceSpeedUpdateFlag) {
            data.updateFlag = '갱신중';
          }
          this.netinterfaceAdminStatusValue = data.netinterfaceStatusAdmin;
          this.formData = data;
        }
      });
    },
    /**
     * form 빈 값 변환
     * @author jeee12
     */
    getValueAfterCheckEmpty,
    /**
     * 숫자 천단위 , 분리 함수
     * @author jeee12
     */
    thousandSep(value) {
      if (value === -1) {
        return '-';
      } else if (value === -2) {
        return 'Auto';
      }
      return getValueAfterCheckEmpty(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    /**
     * Admin, Oper 상태 변환 함수
     * @author jeee12
     * @param  {Number} value Admin, Oper
     * @return {String}       -, UP, DOWN
     */
    convertStatus(value) {
      return Number(getValueAfterCheckEmpty(value)) === 1 ? 'UP' : 'DOWN';
    },
    onSwitchChange(changedValue) {
      if (changedValue !== this.formData.netinterfaceStatusAdmin) {
        this.changedFlag = true;
      } else {
        this.changedFlag = false;
      }
    },
    /**
     * 저장 버튼 클릭
     * @author jeee12
     */
    onSaveButtonClick() {
      this.$confirm('수정하시겠습니까?', '확인', {
        confirmButtonText: '확인',
        cancelButtonText: '취소',
      }).then(() => {
        this.loading = true;
        // netinterfaceStatusAdmin 데이터 (checked === true 면 1, false면 2)
        const jsondata = {
          netinterfaceStatusAdmin: this.netinterfaceAdminStatusValue === 1 ? 1 : 2,
          objName: this.formData.deviceObjName,
          objId: this.formData.objId,
          netinterfaceIfindex: this.formData.netinterfaceIfindex,
          netinterfaceId: this.formData.netinterfaceId,
          netdeviceId: this.formData.deviceId,
        };
        const params = {
          parentObjId: this.parentObjId,
          data: JSON.stringify(jsondata),
        };
        netinterfaceAPI.updateNetinterfaceControlInfo(params).then((response) => {
          const action = msgUtil.action.MODIFY;
          const target = '인터페이스';

          if (response.data.success === true && response.data.data === true) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }

          this.loading = false;
          this.changedFlag = false;
          this.loadData();
        });
      });
    },
    close() {
      this.$refs.slidingPopup.visible = false;
      this.changedFlag = false;
    },
    getInterfaceLabel(value) {
      if (!isEmpty(this.parentLabel)) {
        return this.parentLabel;
      } else if (!isEmpty(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/NetinterfaceControlPopupButton.vue